import "../../components/App.css";
import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Button,
  Grid,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";
import { Alert, Spinner } from "react-bootstrap";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import countryToCurrency from "country-to-currency";
import axios from "axios";
import { API_BASE_URL } from "../../config/config";
import dayjs from "dayjs";
import CaptchaField from "../../components/CaptchaField";
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import CarePlanPaymentHandler from "../../components/Payment/CarePlanPaymentHandler";

const AutoCarePlan = ({ userDetails }) => {
  const [currencies, setCurrencies] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [recaptchaToken, setRecaptchatToken] = useState("");
  const [user, setUser] = useState(null);

  useEffect(() => {}, [selectedImages]);

  useEffect(() => {
    const currencies = Object.values(countryToCurrency);
    const currency = [...new Set(currencies)];
    setCurrencies(currency);
  }, []);

  useEffect(() => {
    const currencies = Object.values(countryToCurrency);
    const currency = [...new Set(currencies)];
    setCurrencies(currency);
  }, []);

  const handleImageChange = (event) => {
    const files = event.target.files;
    setSelectedImages([...files]);
  };

  const handleInvoiceChange = (event) => {
    const file = event.target.files[0];
    setSelectedInvoice(file);
  };

  const calculateCareValues = (values) => {
    let carePercentage;
    switch (values.category) {
      case "Motorhome":
        carePercentage =
          values.productCondition === "New Purchase" ? 0.15 : 0.12;
        break;
      case "Jet Ski":
        carePercentage =
          values.productCondition === "New Purchase" ? 0.2 : 0.18;
        break;
      case "Boats":
        carePercentage =
          values.productCondition === "New Purchase" ? 0.15 : 0.12;
        break;
      case "Snowmobile":
        carePercentage =
          values.productCondition === "New Purchase" ? 0.15 : 0.12;
        break;
      case "Bicycle":
        carePercentage =
          values.productCondition === "New Purchase" ? 0.1 : 0.08;
        break;
      default:
        carePercentage = 0;
    }

    values.careFees = (values.billValue * carePercentage).toFixed(2);

    if (values.productCondition === "New Purchase") {
      values.careValueAmount = Number(values.billValue).toFixed(2);
    } else {
      if (values.oldPurchaseOption === "1-2 years old") {
        values.careValueAmount = (values.billValue * 0.75).toFixed(2);
      } else if (values.oldPurchaseOption === "2-3 years old") {
        values.careValueAmount = (values.billValue * 0.5).toFixed(2);
      } else {
        values.careValueAmount = (values.billValue * 0.25).toFixed(2);
      }
    }
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const formData = new FormData();

      formData.append("email", userDetails.email);
      formData.append("password", userDetails.password);
      formData.append("fName", userDetails.fName);
      formData.append("mName", userDetails.mName);
      formData.append("lName", userDetails.lName);
      formData.append("country", userDetails.country);
      formData.append("state", userDetails.state);
      formData.append("city", userDetails.city);
      formData.append("zip", userDetails.zip);
      formData.append("contact", userDetails.contact);

      values.services.forEach((service, index) => {
        calculateCareValues(service);

        formData.append("invoice", selectedInvoice);

        selectedImages.forEach((image) => {
          formData.append("pictures", image);
        });

        Object.entries(service).forEach(([key, value]) => {
          if (key !== "invoice" && key !== "pictures") {
            formData.append(`services[${index}][${key}]`, value);
          }
        });
      });

      Object.keys(values).forEach((key) => {
        if (key !== "services") {
          formData.append(key, values[key]);
        }
      });

      formData.append("recaptchaToken", recaptchaToken);

      console.log(values);

      await axios.post(`${API_BASE_URL}/register`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const token = localStorage.getItem("care_token");
      const tokenData = jwtDecode(token);
      const userId = tokenData.userId;
      const response = await axios.get(
        `${API_BASE_URL}/user?userId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setUser(response.data.user);
    } catch (error) {
      console.error("Error:", error.response?.data?.error || error.message);
      setError("Error submitting the form");
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  const handleCaptchaChange = (token) => {
    if (token) {
      setRecaptchatToken(token);
    }
  };

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={["DatePicker"]}>
          <Formik
            initialValues={{
              services: [
                {
                  type: "Auto",
                  category: "",
                  productCondition: "",
                  oldPurchaseOption: "",
                  brandName: "",
                  serialNo: "",
                  currency: "",
                  careValueAmount: 0,
                  billValue: "",
                  productPurchaseDate: "",
                  careExpireTimeline: "1 Year",
                  careFees: 0,
                  carePurchaseDate: "",
                  careExpiryDate: "",
                  invoice: "",
                  pictures: [],
                  referralCode: "",
                },
              ],
            }}
            onSubmit={handleSubmit}
          >
            {(formik) => (
              <Form>
                {formik.values.services.map((service, index) => (
                  <div key={index}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].category`}>
                          Select Product Category
                        </InputLabel>
                        <Field
                          as={Select}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].category`}
                          id={`services[${index}].category`}
                        >
                          <MenuItem value="Motorhome">Motorhome</MenuItem>
                          <MenuItem value="Jet Ski">Jet Ski</MenuItem>
                          <MenuItem value="Boats">Boats</MenuItem>
                          <MenuItem value="Snowmobile">Snowmobile</MenuItem>
                          <MenuItem value="Bicycle">Bicycle</MenuItem>
                        </Field>
                        <ErrorMessage name={`services[${index}].category`} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].brandName`}>
                          Brand Name
                        </InputLabel>
                        <Field
                          as={TextField}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].brandName`}
                          id={`services[${index}].brandName`}
                        />
                        <ErrorMessage name={`services[${index}].brandName`} />
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <InputLabel>Product Condition</InputLabel>
                        <FormControl component="fieldset">
                          <Field name={`services[${index}].productCondition`}>
                            {({ field }) => (
                              <>
                                <FormControlLabel
                                  control={<Radio />}
                                  label="New Purchase"
                                  value="New Purchase"
                                  checked={field.value === "New Purchase"}
                                  onChange={() => {
                                    formik.setFieldValue(
                                      `services[${index}].productCondition`,
                                      "New Purchase"
                                    );
                                    formik.setFieldValue(
                                      `services[${index}].oldPurchaseOption`,
                                      ""
                                    );
                                  }}
                                />
                                <FormControlLabel
                                  control={<Radio />}
                                  label="Old Purchase"
                                  value="Old Purchase"
                                  checked={field.value === "Old Purchase"}
                                  onChange={() => {
                                    formik.setFieldValue(
                                      `services[${index}].productCondition`,
                                      "Old Purchase"
                                    );
                                  }}
                                />
                                {field.value === "Old Purchase" && (
                                  <>
                                    <FormControlLabel
                                      control={<Radio />}
                                      label="1-2 years old"
                                      value="1-2 years old"
                                      checked={
                                        formik.values.services[index]
                                          .oldPurchaseOption === "1-2 years old"
                                      }
                                      onChange={() => {
                                        formik.setFieldValue(
                                          `services[${index}].oldPurchaseOption`,
                                          "1-2 years old"
                                        );
                                      }}
                                    />
                                    <FormControlLabel
                                      control={<Radio />}
                                      label="2-3 years old"
                                      value="2-3 years old"
                                      checked={
                                        formik.values.services[index]
                                          .oldPurchaseOption === "2-3 years old"
                                      }
                                      onChange={() => {
                                        formik.setFieldValue(
                                          `services[${index}].oldPurchaseOption`,
                                          "2-3 years old"
                                        );
                                      }}
                                    />
                                    <FormControlLabel
                                      control={<Radio />}
                                      label="More than 3 years old"
                                      value="More than 3 years old"
                                      checked={
                                        formik.values.services[index]
                                          .oldPurchaseOption ===
                                        "More than 3 years old"
                                      }
                                      onChange={() => {
                                        formik.setFieldValue(
                                          `services[${index}].oldPurchaseOption`,
                                          "More than 3 years old"
                                        );
                                      }}
                                    />
                                  </>
                                )}
                              </>
                            )}
                          </Field>
                          <ErrorMessage
                            name={`services[${index}].productCondition`}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].serialNo`}>
                          Product Serial Number
                        </InputLabel>
                        <Field
                          as={TextField}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].serialNo`}
                          id={`services[${index}].serialNo`}
                        />
                        <ErrorMessage name={`services[${index}].serialNo`} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel>Purchase Date</InputLabel>
                        <div className="date-input">
                          <DatePicker
                            format="MM/DD/YYYY"
                            slotProps={{
                              textField: { size: "small", fullWidth: true },
                            }}
                            value={
                              formik.values.services[index].productPurchaseDate
                                ? dayjs(
                                    formik.values.services[index]
                                      .productPurchaseDate
                                  )
                                : null
                            }
                            onChange={(date) => {
                              formik.setFieldValue(
                                `services[${index}].productPurchaseDate`,
                                date && date.isValid()
                                  ? date.format("YYYY-MM-DD")
                                  : null
                              );
                            }}
                          />
                        </div>
                        <ErrorMessage
                          name={`services[${index}].productPurchaseDate`}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].invoice`}>
                          Invoice
                        </InputLabel>
                        <input
                          style={{ width: "100%" }}
                          size="small"
                          type="file"
                          name={`services[${index}].invoice`}
                          id={`services[${index}].invoice`}
                          onChange={handleInvoiceChange}
                          required
                        />
                        <ErrorMessage name={`services[${index}].invoice`} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].pictures`}>
                          Pictures
                        </InputLabel>
                        <input
                          style={{ width: "100%" }}
                          size="small"
                          type="file"
                          name={`services[${index}].pictures`}
                          id={`services[${index}].pictures`}
                          onChange={handleImageChange}
                          multiple
                          required
                        />
                        <ErrorMessage name={`services[${index}].pictures`} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel>Select Currency</InputLabel>
                        <Field
                          as={Select}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].currency`}
                          id={`services[${index}].currency`}
                        >
                          <MenuItem value="">Select Currency</MenuItem>
                          {currencies.map((currency) => (
                            <MenuItem key={currency} value={currency}>
                              {currency}
                            </MenuItem>
                          ))}
                        </Field>
                        <ErrorMessage name={`services[${index}].currency`} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].billValue`}>
                          Product Bill Value
                        </InputLabel>
                        <Field
                          as={TextField}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].billValue`}
                          id={`services[${index}].billValue`}
                        />
                        <ErrorMessage name={`services[${index}].billValue`} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].referralCode`}>
                          Referral Code (If Any)
                        </InputLabel>
                        <Field
                          as={TextField}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].referralCode`}
                          id={`services[${index}].referralCode`}
                        />
                        <ErrorMessage
                          name={`services[${index}].referralCode`}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <InputLabel
                          htmlFor={`services[${index}].careFees`}
                          align="center"
                        >
                          Care Fees to Pay
                        </InputLabel>
                        <Typography
                          variant="h6"
                          align="center"
                          name={`services[${index}].careFees`}
                        >
                          {service.category === "Motorhome" &&
                            (service.productCondition === "New Purchase"
                              ? `${(service.billValue * 0.15).toFixed(2)}`
                              : `${(service.billValue * 0.12).toFixed(2)}`)}
                          {service.category === "Jet Ski" &&
                            (service.productCondition === "New Purchase"
                              ? `${(service.billValue * 0.2).toFixed(2)}`
                              : `${(service.billValue * 0.18).toFixed(2)}`)}
                          {service.category === "Boats" &&
                            (service.productCondition === "New Purchase"
                              ? `${(service.billValue * 0.15).toFixed(2)}`
                              : `${(service.billValue * 0.12).toFixed(2)}`)}
                          {service.category === "Snowmobile" &&
                            (service.productCondition === "New Purchase"
                              ? `${(service.billValue * 0.15).toFixed(2)}`
                              : `${(service.billValue * 0.12).toFixed(2)}`)}
                          {service.category === "Bicycle" &&
                            (service.productCondition === "New Purchase"
                              ? `${(service.billValue * 0.1).toFixed(2)}`
                              : `${(service.billValue * 0.08).toFixed(2)}`)}
                          {service.currency && " " + service.currency}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <InputLabel
                          htmlFor={`services[${index}].careValueAmount`}
                          align="center"
                        >
                          Your Care Value for 1st Year will be
                        </InputLabel>
                        <Typography
                          variant="body1"
                          align="center"
                          name={`services[${index}].careValueAmount`}
                        >
                          {service.productCondition === "New Purchase"
                            ? `${Number(service.billValue).toFixed(2)}`
                            : `${
                                service.oldPurchaseOption === "1-2 years old"
                                  ? (service.billValue * 0.75).toFixed(2)
                                  : service.oldPurchaseOption ===
                                    "2-3 years old"
                                  ? (service.billValue * 0.5).toFixed(2)
                                  : (service.billValue * 0.25).toFixed(2)
                              }`}
                          {service.currency && " " + service.currency}
                        </Typography>
                      </Grid>
                    </Grid>
                  </div>
                ))}
                <CaptchaField
                  onChange={handleCaptchaChange}
                  wrapperStyle={{ display: "flex" }}
                  style={{
                    margin: "0 auto",
                    textAlign: "center",
                    marginTop: "2rem",
                  }}
                />
                <div className="submission-popup">
                  <div className="loading">
                    {loading && <Spinner animation="border" />}
                  </div>
                  {error && <Alert variant="danger">{error}</Alert>}
                  {success && (
                    <Alert variant="success">
                      Form submitted successfully!
                    </Alert>
                  )}
                </div>
                <Grid container spacing={2} justifyContent="center">
                  <Button
                    type="submit"
                    variant="contained"
                    color="success"
                    disabled={loading}
                    style={{ margin: "0.5rem" }}
                  >
                    Submit & Pay
                  </Button>
                </Grid>
              </Form>
            )}
          </Formik>
        </DemoContainer>
      </LocalizationProvider>
      <CarePlanPaymentHandler user={user} userDetails={userDetails} />
      <div style={{ marginTop: "1rem", textAlign: "center" }}>
        <Typography variant="body1">
          Already a user? <Link to="/login">Login</Link>
        </Typography>
      </div>
    </div>
  );
};

export default AutoCarePlan;
